import isEmpty from "lodash-es/isEmpty";
import type { UserProfileState } from "@/types/userProfile";

export const isUserProfileSessionReady = ({
  organisation,
  currentFinancialInstitution,
}: Pick<
  UserProfileState,
  "organisation" | "currentFinancialInstitution"
>): boolean => !isEmpty(organisation) && !isEmpty(currentFinancialInstitution);
